
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue2 as ObiWindTrue2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-2.js';
 
 
 

 
 export const ObiWindTrue2 = createComponent({
   react: React,
   tagName: 'obi-wind-true-2',
   elementClass: ObiWindTrue2Element,
   events: {
     
   }
  });
 
 